export default {
  SERVICE_MAIN_DOMAIN: 'benscm.com/',
  SERVICE_SECOND_DOMAIN: 'supply.benscm.com/',
}
